import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const initialState = {
    data: null,
};

const apiUrl = process.env.REACT_APP_API_URL;

export const formSlice = createSlice({
    name: "Form",
    initialState,
    reducers: {
        setForm: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.data = state.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setForm } = formSlice.actions;

export default formSlice.reducer;

export const formsApi = createApi({
    reducerPath: "formsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

            // If we have a token set in state, let's assume that we should be passing it.
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            headers.set('Content-type', 'application/json')
            headers.set('Accept', 'application/json')
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getForm: builder.query({
            query: (id) => `/forms/${id}?populate=*`,
        }),
        getForms: builder.query({
            query: (id) => `/forms`,
        }),
        getFieldsByForm: builder.query({
            query: (id) => `/fields?populate=*&filters[forms][id][$eq]=${id}`,
        }),

        postForm: builder.mutation({
            query: (data) => ({
                url: `/forms`,
                method: "POST",
                body: data,
            }),


        }),



    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFormQuery, usePostFormMutation, useLazyGetFormQuery, useLazyGetFieldsByFormQuery } = formsApi;
